// export const root_url = "https://13.231.8.81:8080";
// export const root_url = "http://localhost:8080";
export const root_url = "https://ocialmedia-backend.onrender.com";